import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditLineIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 10C5 9.27596 6.53043 3.32605 8.45139 5.45926C10.1241 7.31679 7.38305 10.3829 12 9.49547",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
export default SvgEditLineIcon;
